import { render, staticRenderFns } from "./WorkspacesView.vue?vue&type=template&id=772ced2c&"
import script from "./WorkspacesView.vue?vue&type=script&lang=js&"
export * from "./WorkspacesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports